import { render, staticRenderFns } from "./RemessaOperacoes.vue?vue&type=template&id=50e97a74"
import script from "./RemessaOperacoes.vue?vue&type=script&lang=js"
export * from "./RemessaOperacoes.vue?vue&type=script&lang=js"
import style0 from "./RemessaOperacoes.vue?vue&type=style&index=0&id=50e97a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports